<template>
  <div>
    <v-card class="transparent elevation-0">
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12" :class="{'text-center': $vuetify.breakpoint.smAndDown}">
            <h1>Linehaul Schedule</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <div style="display: flex; justify-content: center; align-items: center">
            <v-btn text @click="refresh" v-if="!isVisible">
              <v-icon color="cyan darken-2">refresh</v-icon>
            </v-btn>
            <div v-if="isVisible" class="load-3">
              <div class="line"></div>
              <div class="line"></div>
              <div class="line"></div>
            </div>
          </div>

          <v-spacer></v-spacer>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-data-table
        :search="search"
        :headers="scheduleHeaders"
        :items="renderedSLinehaulSchedule"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in scheduleHeaders" :key="index">
              {{props.item[header.value]}}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "LinehaulSchedule",
  components: {

  },
  props: {
  },
  data(){
    return {
      linehaulScheduleDialog:false,
      destinationDepot:0,
      climate:'',
      client:null,
      search: '',
      valid:false,
      loading:false,
      reload: false,
      EditOrCreateSchedule:'',
      editLinehaulSchedule:null,
      toBeDeletedLineHaul:null,
      deleteDialog:false,
      departureDay:'',
      authDialog: false,
      authAction: null,
      authId: null,
      selectDays:[
        'Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'
      ],
      arrivalDay:'',
      isVisible: false,
      scheduleHeaders:[
        {text: 'Id', value: 'id', align: 'center', sortable: true},
        {text: 'Client', value: 'client_name', align: 'center', sortable: true},
        {text: 'Origin', value: 'origin_depot_name', align: 'center', sortable: true},
        {text: 'Destination', value: 'destination_depot_name', align: 'center', sortable: true},
        {text: 'Destination Code', value: 'destination_depot_code', align: 'center', sortable: true},
        {text: 'Departure Day', value: 'departure_day', align: 'center', sortable: false},
        {text: 'Arrival Day', value: 'arrival_day', align: 'center', sortable: false},
        {text: 'Climate', value: 'climateName', align: 'center', sortable: false}
      ],

    }

  },
  mounted: function () {
    this.timer = setInterval(() => {
      this.reload = !this.reload;
    }, 300000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  computed: {
    renderedSLinehaulSchedule(){
      if (this.lineHaulsSchedule === null || this.lineHaulsSchedule === undefined) {
        return [];
      } else {
        this.getClimate(this.lineHaulsSchedule);
        return this.lineHaulsSchedule;
      }
    }
  },
  asyncComputed: {
    async lineHaulsSchedule() {
      if (this.reload || !this.reload) {
        this.loading = true;
        return await axios.get(process.env.API_URL + '/linehauls/schedule?client_id=' + this.$store.state.auth.client.id)
          .then((response) => {
            if (response.status === 200) {
              this.loading = false;
              return response.data;
            } else {
              this.loading = false;
              return [];
            }
          })
          .catch((error) => {
            this.loading = false;
            return [];
          });
      }
    }
  },
  methods: {
    updateDataTable() {
      this.reload = !this.reload;
    },
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    },
    getClimate(lineHauls) {
      let index;
      for (index in lineHauls) {
        if (lineHauls[index]['climate'] && lineHauls[index]['climate']['name']) {
          lineHauls[index]['climateName'] = lineHauls[index]['climate']['name'];
        } else {
          lineHauls[index]['climateName'] = 'N/A';
        }
      }
    },
  }
}
</script>

<style scoped>
.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/LinehaulSchedule.vue